import React, { useState } from 'react';

export default function Contact() {
  const [status, setStatus] = useState(null); // null | 'ok' | 'err'
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setStatus(null);
    const form = e.target;
    const data = new FormData(form);

    try {
      const res = await fetch('https://formspree.io/f/xpqepgqb', {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' },
      });
      if (res.ok) {
        setStatus('ok');
        form.reset();
      } else {
        setStatus('err');
      }
    } catch {
      setStatus('err');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section id="contact" className="contact">
      <div className="contact__inner">
        {/* Left info column */}
        <div className="contact__info">
          <span className="section-label">Get in Touch</span>
          <h2 className="contact__title">
            Let's build<br />something<br /><em>remarkable.</em>
          </h2>
          <p className="contact__blurb">
            Whether you have a precise brief or a rough idea, we would love to hear
            from you. Tell us about your project and we will get back to you within
            one business day.
          </p>
          <div className="contact__details">
            <div className="contact__detail">
              <span className="contact__detail-label">Email</span>
              <span className="contact__detail-val">contact@oldmonktech.com</span>
            </div>
            <div className="contact__detail">
              <span className="contact__detail-label">Phone</span>
              <span className="contact__detail-val">(+91)-8875517770</span>
            </div>
            <div className="contact__detail">
              <span className="contact__detail-label">Office</span>
              <span className="contact__detail-val">Pilani<br />Rajasthan</span>
            </div>
          </div>
        </div>

        {/* Right form column */}
        <form className="contact__form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-field">
              <label htmlFor="first_name">First Name</label>
              <input id="first_name" type="text" name="first_name" placeholder="Rahul" required />
            </div>
            <div className="form-field">
              <label htmlFor="last_name">Last Name</label>
              <input id="last_name" type="text" name="last_name" placeholder="Agarwal" required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-field">
              <label htmlFor="email">Email Address</label>
              <input id="email" type="email" name="email" placeholder="you@company.com" required />
            </div>
            <div className="form-field">
              <label htmlFor="mobile">Mobile Number</label>
              <input id="mobile" type="tel" name="mobile" placeholder="+91 9876543210" required />
            </div>
          </div>

          <div className="form-field">
            <label htmlFor="concern">What are you working on?</label>
            <textarea
              id="concern"
              name="concern"
              placeholder="Tell us about your project, timeline, and any specific requirements..."
              required
            />
          </div>

          <div>
            <button type="submit" className="form-submit" disabled={submitting}>
              {submitting ? 'Sending…' : 'Send Message →'}
            </button>
          </div>

          {status === 'ok' && (
            <div className="form-status form-status--ok">
              ✓ Message sent — we'll be in touch within one business day.
            </div>
          )}
          {status === 'err' && (
            <div className="form-status form-status--err">
              Something went wrong. Please email us directly at contact@oldmonktech.com
            </div>
          )}
        </form>
      </div>
    </section>
  );
}
